export const api = {
  API_URL: process.env.REACT_APP_API_URL || "https://localhost:44311/api",
  SESSION_SERVICE: "/Session",
  TOKEN_SERVICE: "/TokenAuth",
  RECEIPT_SERVICE: "/Receipt",
  REMISION_SERVICE: "/Remision",
  CLIENT_SERVICE: "/Client",
  PRODUCT_SERVICE: "/Product",
  TRANSACTION_SERVICE: "/Transaction",
  REPORT_SERVICE: "/Report",
};
